export function formatPhoneNumber(number: string) {
  const trimmed = ('' + number).replace(/\D/g, '');
  const converted = trimmed.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !converted ? '' : converted[1] + '-' + converted[2] + '-' + converted[3];
}